export default __webpack_public_path__ + "static/media/m_use_action_back_cz.d5030921.png";